import React from "react";
import { AnimatedList } from "react-animated-list";

const Animationlist = ({ children }) => {
  return <AnimatedList animation={"grow"}>{children}</AnimatedList>;
};

export default Animationlist;
